/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/prop-types */
import { makeStyles } from "@material-ui/core";
import "chartjs-plugin-annotation";
import { Bubble } from "react-chartjs-2";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1),
    maxWidth: "min(75vw)",
    aspectRatio: "2 / 1",
    maxHeight: "50vh",
    position: "relative",
    margin: "0 auto",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "95vw",
      maxHeight: "40vh",
    },
  },
}));

const PromotionsBubbleChartComponent = ({
  chartData,
  chartOptions,
  setPromotionsChartFilters,
}) => {
  const classes = useStyles();

  const handleBubbleClick = (elems) => {
    if (elems && elems.length > 0) {
      const datasetIndex = elems[0]._datasetIndex;
      const index = elems[0]._index;
      const bubble = chartData.datasets[datasetIndex].data[index];
      setPromotionsChartFilters((prev) => {
        if (prev === bubble.id) return "";
        return bubble.id;
      });
    }
  };

  return (
    <div className={classes.root}>
      <Bubble
        data={chartData}
        options={chartOptions}
        getElementAtEvent={handleBubbleClick}
      />
    </div>
  );
};

export default PromotionsBubbleChartComponent;
